import { render } from "./NotesSideBar.vue?vue&type=template&id=152b6a3c"
import script from "./NotesSideBar.vue?vue&type=script&lang=js"
export * from "./NotesSideBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__